import React from "react";

import CSSModules from "lib/utils/css-modules";
import st from "lib/utils/index";
import { Link, Button } from "lib/components/vendor";
import styles from "./AgentCooperationsListItem.less";

@CSSModules(styles)
export default class AgentCooperationsListItem extends React.PureComponent {
  render() {
    const { record: coop, currentCompanyId } = this.props;
    const shownCompany = currentCompanyId === coop.agent.id ? "supplier" : "agent";
    const coopCompany = coop[shownCompany];
    const linkUrl =
      shownCompany === "supplier"
        ? `/c/${currentCompanyId}/suppliers/${coop.id}`
        : `/c/${currentCompanyId}/agents/${coop.id}`;

    return (
      <Link as="a" to={linkUrl} styleName="item">
        <div styleName="item-image">
          <img src={st.getAttachmentImageUrl(coopCompany, "logo_image", "thumb")} />
        </div>
        <div styleName="item-content">
          <div styleName="item-title">
            <div styleName="item-title-company_name">{coopCompany.name}</div>
          </div>
          <div styleName="item-subtitle">{coop.pricing_type_i18n}</div>
          <div styleName="item-metas">
            {!!coopCompany.contact_phone_number && (
              <div styleName="item-meta">
                <span className="with-icon">
                  <i className="icon material-icons">phone</i>
                  <span className="text">{coopCompany.contact_phone_number}</span>
                </span>
              </div>
            )}
            {!!coopCompany.contact_email && (
              <div styleName="item-meta">
                <span className="with-icon">
                  <i className="icon material-icons">email</i>
                  <span className="text">{coopCompany.contact_email}</span>
                </span>
              </div>
            )}
          </div>
        </div>
        <div styleName="item-read-more-button">
          <i className="icon material-icons">chevron_right</i>
        </div>
      </Link>
    );
  }
}



// WEBPACK FOOTER //
// ./src/lib/components/list/AgentCooperationsListItem.jsx